import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const downloadParticipantsApi = createApi({
  reducerPath: 'downloadParticipantsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
